var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('layout-header',{attrs:{"context":_vm.context}}),_c('router-view',{attrs:{"context":_vm.context}}),(_vm.isLoading)?_c('div',{staticClass:"loading-overlay"},[_c('loader')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }